package com.neurobs.ccab

import com.neurobs.util.PlainDate


case class SubjectIdentityData
(
	firstName: Option[String],
	lastName: Option[String],
	birthdate: Option[PlainDate],
	birthYear: Int,
	sex: Sex.Value,
	localID: Option[String]
) {
	/** string description of all the data */
	def summary: String = {
		val bd = Some(birthSummary)

		List(firstName, lastName, bd, Some(sex.toString)).flatten.mkString(", ")
	}
	
	def birthSummary: String = birthdate.map(_.toString).getOrElse(birthYear.toString)

	/** A representation of the name given the non-empty elements
	 *
	 * @param default Value to return if firstName, lastName, and localID are all empty
	 * @return name
	 */
	def displayName(default: String): String = {
		if (firstName.nonEmpty || lastName.nonEmpty) {
			List(firstName, lastName).flatten.mkString(" ") + localID.map(i => s" ($i)").getOrElse("")
		}
		else localID.getOrElse(default)
	}

	/** Used to check that users don't accidentally create subjects with duplicate names or ids */
	def duplicateName(other: SubjectIdentityData): Boolean = {
		if (localID.isDefined && other.localID.isDefined) localID == other.localID
		else firstName == other.firstName && lastName == other.lastName && localID == other.localID
	}

	def <(that: SubjectIdentityData): Boolean = {
		def getString(v: Option[String]): String = v.map(_.toLowerCase).getOrElse("")
		val last1 = getString(lastName)
		val last2 = getString(that.lastName)
		if (last1 != last2) last1 < last2
		else {
			val first1 = getString(firstName)
			val first2 = getString(that.firstName)
			if (first1 != first2) first1 < first2
			else {
				val id1 = getString(localID)
				val id2 = getString(that.localID)
				id1 < id2
			}
		}
	}
}